import Auth from '@/packages/auth/Auth';

Vue.use(Auth);

export default {
    mixins: {
        global
    },
    state: {
        signupSuccess: false
    },

    actions: {
        login(context, payload) {
            const url = `${api}login`;
            return context
                .dispatch('post', {
                    url,
                    data: {
                        ...payload.user,
                        client_id: process.env.VUE_APP_LUDUM_CLIENT_ID,
                        client_secret: process.env.VUE_APP_LUDUM_CLIENT_SECRET,
                        grant_type: 'password'
                    }
                })
                .then(response => {
                    let tokenData = response.data.accessToken;

                    // Save token to cookies for 30 days
                    Vue.auth.setToken(tokenData, '30D');

                    context.dispatch('manageSelectedLanguage');

                    return response;
                });
        },

        manageSelectedLanguage() {
            if (!localStorage.getItem('language') || !(Vue.cookie && Vue.cookie.get('language'))) {
                Vue.cookie.set('language', 'en');
                localStorage.setItem('language', 'en');
            }
        },

        signup(context, payload) {
            // if we dispatch a user with an id, that means
            // they're coming from vendor. In that case, account is
            // already registered but inactive and we need to update
            // the user, not create one
            const url = payload.id ? 'account-details' : 'register';
            return context.dispatch('post', {
                url: `${api}${url}`,
                data: payload
            });
        }
    }
};
